import { type FC } from 'react';

import { ActivityStatus } from 'connect-graphql/generated';

import Chip from '@mui/material/Chip';

export interface ScoreChipProps {
  readonly score?: null | number;
  readonly status: ActivityStatus;
}

export const ScoreChip: FC<ScoreChipProps> = ({ score, status }) => {
  if (score === null) {
    return null;
  }

  const color = status === ActivityStatus.Returned ? 'warning' : 'success';

  const variant = status === ActivityStatus.Returned ? 'outlined' : 'filled';

  return <Chip color={color} label={score} size='small' variant={variant} />;
};
